<template>
  <v-container class="contenedor-ppal">
    <v-overlay :value="loading">
      <div class="loader"></div>
    </v-overlay>

    <!-- Header -->
    <v-card elevation="4" class="mb-5">
      <v-toolbar flat elevation="4">
        <v-card class="icon">
          <v-icon
            style="margin-left: 30px; margin-top: 25px"
            color="white"
            x-large
          >
            mdi-account-off
          </v-icon>
        </v-card>
        <div class="usuario">USUARIOS INACTIVOS</div>
        <v-spacer></v-spacer>
      </v-toolbar>
    </v-card>

    <!-- Filtros y tabla -->
    <v-card class="mt-5">
      <v-card-text>
        <div class="d-flex justify-space-between align-center mb-3">
          <!-- Filtro de empresa a la izquierda -->
          <div style="width: 300px;">
            <v-select
              v-model="filtroEmpresa"
              :items="empresas"
              item-text="nombre"
              item-value="idEmpresa"
              label="Filtrar por empresa"
              outlined
              dense
              clearable
              hide-details
            ></v-select>
          </div>
          
          <!-- Botón de actualizar a la derecha -->
          <v-btn
            color="#1D3C7F"
            dark
            @click="cargarUsuariosInactivos"
            :loading="loading"
          >
            <v-icon left>mdi-refresh</v-icon>
            Actualizar
          </v-btn>
        </div>

        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar usuario"
          class="text-field mb-3"
          single-line
          color="#111c3d"
          clearable
        ></v-text-field>

        <!-- Botones de acción masiva -->
        <div class="d-flex justify-end mb-3" v-if="selected.length > 0">
          <v-chip class="mr-3" color="primary" outlined>
            {{ selected.length }} usuario(s) seleccionado(s)
          </v-chip>
          <v-btn
            color="green darken-2"
            dark
            @click="activarMultiplesUsuarios"
            :loading="activandoMultiple"
          >
            <v-icon left>mdi-account-check-multiple</v-icon>
            Activar seleccionados
          </v-btn>
        </div>

        <v-data-table
          :headers="headers"
          :items="usuariosInactivos"
          :search="search"
          :loading="loading"
          :items-per-page="10"
          loading-text="Cargando usuarios inactivos..."
          class="elevation-3"
          style="border: 2px solid #111c3d"
          v-model="selected"
          show-select
          item-key="idUsuario"
        >
          <!-- Estado badge -->
          <template v-slot:[`item.estado`]="{ item }">
            <v-chip color="red darken-2" outlined dark>
              <v-icon left small>mdi-account-off</v-icon>
              INACTIVO
            </v-chip>
          </template>

          <!-- Empresa - SIN COLORES, texto normal -->
          <template v-slot:[`item.nombre_empresa`]="{ item }">
            <span>{{ item.nombre_empresa || 'SIN EMPRESA' }}</span>
          </template>

          <!-- Acciones -->
          <template v-slot:[`item.actions`]="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  icon
                  color="green darken-2"
                  @click="activarUsuario(item)"
                  :loading="activando === item.idUsuario"
                >
                  <v-icon>mdi-account-check</v-icon>
                </v-btn>
              </template>
              <span>Activar usuario</span>
            </v-tooltip>
          </template>

          <template v-slot:no-data>
            <v-alert :value="true" color="#111c3d" icon="mdi-alert" outlined>
              No hay usuarios inactivos para mostrar
            </v-alert>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <!-- Snackbar -->
    <v-snackbar
      v-model="snackbar"
      :timeout="3000"
      :color="snackbarColor"
      top
      right
    >
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false">
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import axios from "axios";
import env from "@/components/env";
import swal from "sweetalert";

export default {
  name: "UsuariosInactivos",
  data: () => ({
    loading: false,
    activando: null,
    activandoMultiple: false,
    selected: [],
    search: "",
    filtroEmpresa: null,
    usuariosInactivos: [],
    empresas: [],
    snackbar: false,
    snackbarText: "",
    snackbarColor: "success",
    headers: [
      { text: "ID", value: "idUsuario", align: "center", class: "column", width: "80" },
      { text: "Cédula", value: "cedula", align: "center", class: "column" },
      { text: "Nombre", value: "nombre", align: "center", class: "column" },
      { text: "Correo", value: "correo", align: "center", class: "column" },
      { text: "Celular", value: "celular", align: "center", class: "column", width: "120" },
      { text: "Rol", value: "nombre_rol", align: "center", class: "column" },
      { text: "Empresa", value: "nombre_empresa", align: "center", class: "column", width: "120" },
      { text: "Estado", value: "estado", align: "center", class: "column", width: "100" },
      { text: "Acciones", value: "actions", sortable: false, align: "center", class: "column", width: "100" },
    ],
  }),
  watch: {
    filtroEmpresa() {
      this.cargarUsuariosInactivos();
    },
    // Agregar watcher para debug
    selected: {
      handler(val) {
        console.log("Usuarios seleccionados:", val);
      },
      deep: true
    }
  },
  mounted() {
    this.cargarEmpresas();
    this.cargarUsuariosInactivos();
  },
  methods: {
    /**
     * Cargar empresas disponibles para filtro
     */
    cargarEmpresas() {
      axios.get(`${env.endpoint}user/empresas`)
        .then((response) => {
          this.empresas = response.data || [];
        })
        .catch((error) => {
          console.error("Error cargando empresas:", error);
        });
    },

    /**
     * Cargar todos los usuarios con estado = 0
     */
    cargarUsuariosInactivos() {
      this.loading = true;
      let url = `${env.endpoint}user/usuariosInactivos`;
      
      const params = [];
      if (this.filtroEmpresa) params.push(`empresa=${this.filtroEmpresa}`);
      if (params.length) url += `?${params.join('&')}`;
      
      axios.get(url)
        .then((response) => {
          this.usuariosInactivos = response.data || [];
          this.selected = []; // Limpiar selección al cargar
        })
        .catch((error) => {
          console.error("Error cargando usuarios inactivos:", error);
          this.mostrarSnackbar("Error al cargar los usuarios inactivos", "error");
        })
        .finally(() => {
          this.loading = false;
        });
    },

    /**
     * Activar un usuario (cambiar estado a 1)
     */
    activarUsuario(usuario) {
      swal({
        title: "¿Activar usuario?",
        text: `¿Estás seguro de activar al usuario ${usuario.nombre}?`,
        icon: "warning",
        buttons: ["Cancelar", "Sí, activar"],
        dangerMode: true,
      }).then((willActivate) => {
        if (willActivate) {
          this.activando = usuario.idUsuario;
          axios
            .put(`${env.endpoint}user/activarUsuario/${usuario.idUsuario}`)
            .then((response) => {
              if (response.data.success) {
                this.mostrarSnackbar(`Usuario ${usuario.nombre} activado correctamente`, "success");
                this.cargarUsuariosInactivos();
              } else {
                this.mostrarSnackbar(response.data.message || "Error al activar usuario", "error");
              }
            })
            .catch((error) => {
              console.error("Error activando usuario:", error);
              this.mostrarSnackbar("Error al activar el usuario", "error");
            })
            .finally(() => {
              this.activando = null;
            });
        }
      });
    },

    /**
     * Activar múltiples usuarios
     */
    activarMultiplesUsuarios() {
      console.log("Selected antes de activar:", this.selected);
      
      if (this.selected.length === 0) {
        this.mostrarSnackbar("No hay usuarios seleccionados", "warning");
        return;
      }
      
      swal({
        title: "¿Activar usuarios?",
        text: `¿Estás seguro de activar ${this.selected.length} usuario(s)?`,
        icon: "warning",
        buttons: ["Cancelar", "Sí, activar todos"],
        dangerMode: true,
      }).then((willActivate) => {
        if (willActivate) {
          this.activandoMultiple = true;
          const ids = this.selected.map(u => u.idUsuario);
          
          console.log("IDs a activar:", ids);
          
          // Enviar como JSON con Content-Type explícito
          axios({
            method: 'post',
            url: `${env.endpoint}user/activarMultiplesUsuarios`,
            data: { ids: ids },
            headers: {
              'Content-Type': 'application/json'
            }
          })
          .then((response) => {
            console.log("Respuesta:", response.data);
            if (response.data.success) {
              this.mostrarSnackbar(response.data.message, "success");
              this.cargarUsuariosInactivos();
            } else {
              this.mostrarSnackbar(response.data.message || "Error al activar usuarios", "error");
            }
          })
          .catch((error) => {
            console.error("Error activando usuarios:", error);
            if (error.response) {
              console.error("Respuesta del servidor:", error.response.data);
              this.mostrarSnackbar(error.response.data?.message || "Error al activar los usuarios", "error");
            } else {
              this.mostrarSnackbar("Error al activar los usuarios", "error");
            }
          })
          .finally(() => {
            this.activandoMultiple = false;
          });
        }
      });
    },

    /**
     * Mostrar snackbar con mensaje
     */
    mostrarSnackbar(mensaje, tipo = "success") {
      this.snackbarText = mensaje;
      this.snackbarColor = tipo === "error" ? "error" : tipo === "warning" ? "warning" : "success";
      this.snackbar = true;
    },
  },
};
</script>

<style scoped>
.contenedor-ppal {
  border: 1px solid #111c3d;
  padding-bottom: 40px !important;
  border-radius: 5px;
}

.text-field {
  border: 2px solid #111c3d;
  padding: 5px;
  border-radius: 5px;
}

.usuario {
  font-size: 1.5rem;
  font-weight: bold;
  color: white;
  margin-left: 15px;
}

.icon {
  background-color: #1D3C7F;
  width: 100px;
  height: 100px;
  border-radius: 10px;
  margin-right: 20px;
}

.loader {
  width: 50px;
  padding: 8px;
  aspect-ratio: 1;
  border-radius: 50%;
  background: #2981ec;
  --_m: conic-gradient(#0000 10%, #000), linear-gradient(#000 0 0) content-box;
  -webkit-mask: var(--_m);
  mask: var(--_m);
  -webkit-mask-composite: source-out;
  mask-composite: subtract;
  animation: l3 1s infinite linear;
}

@keyframes l3 {
  to {
    transform: rotate(1turn);
  }
}
</style>